import {
  isShopifyImageUrl,
  adjustShopifyImageUrl
} from './shopifyImageUtils.js'

import {
  isAwsImageUrl,
  adjustAwsImageUrl
} from './awsImageUtils.js'

import {
  isAwsCdnImageUrl,
  adjustAwsCdnImageUrl
} from './awsCdnImageUtils.js'

export const adjustImageUrl = (url, options) => {
  if (isShopifyImageUrl(url)) {
    return adjustShopifyImageUrl(url, options)
  }

  if (isAwsCdnImageUrl(url)) {
    return adjustAwsCdnImageUrl(url, options)
  }

  if (isAwsImageUrl(url)) {
    return adjustAwsImageUrl(url, options)
  }

  return url
}